import React from "react";

/** Intentionally empty — to be developed later. Header chrome handles itself. */
export default function Immersion() {
  return <main className="min-h-[100dvh] bg-[#FAF9F6]" data-testid="immersion-page" />;
}
